// Hovering (or focusing) a variant swatch on a product card previews that variant's image.
(function () {
  function preview(swatch) {
    var card = swatch.closest('.grid-product');
    var img = card && card.querySelector('.grid-product__image-mask img');
    if (!img) return;
    img.removeAttribute('data-srcset');
    img.srcset = swatch.dataset.swatchSrcset;
    img.src = swatch.dataset.swatchSrc;
    card.classList.add('is-swatched');
    card.querySelectorAll('[data-swatch-src]').forEach(function (el) {
      el.classList.toggle('is-active', el === swatch);
    });
  }
  ['mouseover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var swatch = e.target.closest && e.target.closest('[data-swatch-src]');
      if (swatch) preview(swatch);
    });
  });
})();
